import axiosInstance from './axios';
import { handleError } from './utils';

const roleService = {
  getRoles: async () => {
    try {
      const response = await axiosInstance.get('/roles');
      if (response.status !== 200) {
        throw new Error('Failed to fetch roles');
      }
      const data = response.data;
      return data || null;
    } catch (error) {
      handleError(error);
    }
  },

  createRole: async (role) => {
    try {
      const response = await axiosInstance.post('/roles', role);
      if (response.status !== 200) {
        throw new Error('Failed to create role');
      }
      const data = response.data;
      return data || null;
    } catch (error) {
      handleError(error);
    }
  },

  updateRole: async (role) => {
    try {
      const response = await axiosInstance.put(`/roles`, role);
      if (response.status !== 200) {
        throw new Error('Failed to update role');
      }
      const data = response.data;
      return data || null;
    } catch (error) {
      handleError(error);
    }
  },

  deleteRole: async (roleKey) => {
    try {
      const response = await axiosInstance.delete(`/roles`, {
        data: { roleKey },
      });
      if (response.status !== 200) {
        throw new Error('Failed to delete role');
      }
      const data = response.data;
      return data || null;
    } catch (error) {
      handleError(error);
    }
  },
};
export default roleService;
